export const serviceConfigs = [
	{
		base_url: 'https://api.bebin.com/api',
		version: '/v1/'
	},
	{
		base_url: 'https://api.bebin.com/api',
		version: '/v2/'
	},
	{
		base_url: 'https://api.bebin.com/api',
		version: '/v3/'
	}
];

export const services_api_names = {
	home_page_data          : 'home/movies',
	series_landings         : 'home/series',
	register                : 'users/register',
	verify                  : 'users/verify',
	credentials             : 'users/credentials',
	authenticate            : 'users/authenticate',
	forget_password         : 'users/credentials/reset',
	profile                 : 'users/profile',
	profile_update_principal: 'users/profile/principal/verify',
	// search                  : 'vod/search/',
	search                  : 'vod/search/filter',
	search_intro_movies     : 'vod/search/intro/movies',
	search_intro_series     : 'vod/search/intro/series',
	category_list			: 'vod/search/filter/category',
	genre_list			    : 'vod/search/filter/genre',
	allItems     			: 'vod/search/filter/allItems',
	search_filter     		: 'vod/search/filter'
};

export const render_type = {
	slider  : 'SLIDER',
	list  : 'LIST',
	genres  : 'GENRES',
	carousel  : 'CAROUSEL',
	banner    : 'BANNER',
	horizontal: 'HORIZONTAL',
	vertical  : 'VERTICAL'
};

export const render_object_type = {
	movie : 'MOVIE',
	series: 'SERIES',
	show  : 'SHOW',
	tag   : 'TAG',
	media : 'MEDIA'
};

export const variable_names = {
	token             : 'X-USER-TOKEN',
	principal         : 'X-USER-PRINCIPAL',
	user_is_login     : 'X-LOGIN-USER',
	is_forget_password: 'X-FORGET-CREDENTIAL'
};

export const media_list = {
	BEBIN : {
		media_id:  '63ed22cd205da02be5507db1',
		title: 'ببین',
		titleEn: 'bebin',
		logo: 'bebin-logo.svg'
	},
	ROKNA : {
		media_id:  '65e7351c1089e05f68e3bfc2',
		title: 'روکنا',
		titleEn: 'rokna',
		logo: 'rokna-logo.svg'
	},
	EGHTESAD100 : {
		media_id:  '65e735351089e05f68e3bfc5',
		title: 'اقتصاد ۱۰۰',
		titleEn: 'eghtesad100',
		logo: 'eghtesad-100_new.png'
	},
	MONIBAN : {
		media_id:  '65e735581089e05f68e3bfc8',
		title: 'منیبان',
		titleEn: 'moniban',
		logo: 'moniban-logo.webp'
	},
	BARTARINHA : {
		media_id:  '65e7356b1089e05f68e3bfcb',
		title: 'برترین ها',
		titleEn: 'bartarinha',
		logo: 'bartarinha-logo.png'
	},
	CHILBEPOOSHAM : {
		media_id:  '65e735801089e05f68e3bfce',
		title: 'چی بپوشم',
		titleEn: 'chilbepoosham',
		logo: 'chilbepoosham-logo.png'
	},
	NINIBAN : {
		media_id:  '65e735a41089e05f68e3bfd1',
		title: 'نی نی بان',
		titleEn: 'niniban',
		logo: 'niniban-logo.png'
	},
	DOOSTIHAA : {
		media_id:  '63fc67f7205da02be5507e0d',
		title: 'دوستی ها',
		titleEn: 'doostihaa',
		logo: 'doostihaa-logo.png'
	},
	JABEH : {
		media_id:  '64f6c825a174654d045c67c0',
		title: 'جعبه',
		titleEn: 'jabeh',
		logo: 'jabeh_logo.svg'
	},
	FILMMUSICA : {
		media_id:  '64ec6acf554f291378586aac',
		title: 'فیلم موزیکا',
		titleEn: 'filmmusica',
		logo: 'filmmusica_logo.jpg'
	},
	MYRAMSHEH : {
		media_id:  '661114b1257cb90537957475',
		title: 'نوای رامشه',
		titleEn: 'myramsheh',
		logo: 'myramsheh_logo.png'
	},
	CINEMABARTAR : {
		media_id:  '66150781257cb905379578c4',
		title: 'سینما برتر',
		titleEn: 'cinemabartar',
		logo: 'cinemabartar_logo.svg'
	},
	AKHARINKHABAR : {
		media_id:  '656376a8d97f213072572edb',
		title: 'آخرین خبر',
		titleEn: 'akharinkhabar',
		logo: 'akharinkhabar-logo.svg'
	},
	BEHMI : {
		media_id:  '6659ec47db8c8c40a33b1450',
		title: 'بهمی',
		titleEn: 'behmi',
		logo: 'behmi-logo.svg'
	},
	ENJOYMOVIE : {
		media_id:  '',
		title: 'اینجوی مووی',
		titleEn: 'enjoymovie',
		logo: 'enjoymovie-logo.png'
	},
	MUSICSETAREH : {
		media_id:  '',
		title: 'موزیک ستاره',
		titleEn: 'musicsetareh',
		logo: 'musicsetareh-logo.png'
	},
}

// export const config_site = {
// 	media: media_list.BEBIN,
// }